<template>
  <div>
    <ConfirmModal
      :title="t('UserManagement.CreateUser.attachPersonalMessageText')"
      :show-floating-close-button="false"
      :approve="t('UserManagement.CreateUser.CTAs.create')"
      data-testid="user-create-modal"
      @close-dialog="handleCloseDialog"
    >
      <template #content>
        <TextInput
          id="message"
          v-model="personalMessage"
          type="textarea"
          class="px-6"
          data-testid="user-create-msg"
          :max-length="750"
          :label="t('UserManagement.CreateUser.attachPersonalMessageLabel')"
        />
      </template>
    </ConfirmModal>
  </div>
</template>
<script setup lang="ts">
import { TextInput } from '@ramp106/omrjs-core-ui/deprecated'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import type { CreateUserMutationVariables, RoleNameEnum } from '@/gql/myomr'

const props = defineProps<{
  email: string
  roleNames: RoleNameEnum[]
}>()

const { t } = useI18n()

const personalMessage = ref('')

const emit = defineEmits<{
  (e: 'closeModal'): void
  (e: 'sendInvitation', value: CreateUserMutationVariables): void
}>()

function handleCloseDialog(confirmed: boolean) {
  if (!confirmed) return emit('closeModal')
  return emit('sendInvitation', { email: props.email, roleNames: props.roleNames, personalMessage: personalMessage.value })
}
</script>
